'use strict';

frontendApp.directive('iioTheme', ['$rootScope', 'ThemeService', function ($rootScope, ThemeService) {

  var makeStyle = function (tag, styleObj) {
    var style = tag + ' { ';
    angular.forEach(_.pairs(styleObj), function (pair) {
      style += pair[0] + ': ' + pair[1] + '; ';
    });
    style += " }\n";
    return style;
  };

  var getThemeCss = function (theme) {
    var css = '';

    var linkColor = pusher.color(theme.linkColor);
    var navColor = pusher.color(theme.navBackgroundColor);
    var backgroundColor = pusher.color(theme.backgroundColor);
    var textColor = pusher.color(theme.textColor);

    var lightLinkColor = linkColor.tint(.2).hex6();
    var darkLinkColor = linkColor.shade(.15).hex6();
    var primaryHighlight = linkColor.hue('+10').hex6();
    var primaryActive = linkColor.shade(.10).hex6();

    var textOverLinkColor = linkColor.contrastWhiteBlack().hex6();


    css += makeStyle('body', {
      'background-color': theme.backgroundColor,
      'color': theme.textColor
    });

    css += makeStyle('a', {
      'color': theme.linkColor
    });
    css += makeStyle('a:hover, a:focus', {
      'color': darkLinkColor
    });

    css += makeStyle('h1 small, h2 small, h3 small, h4 small, h5 small, h6 small', {
      'color': backgroundColor.shade(.3).hex6()
    });

    // IIO Layout overrides

    css += makeStyle('h2 i', {
      'color': backgroundColor.shade(.15).hex6()
    });

    css += makeStyle('.breadcrumb', {
      'background-color': backgroundColor.shade(.1).hex6()
    });

    css += makeStyle('.breadcrumb > li', {
      'text-shadow': '0 1px 0 ' + backgroundColor.hex6()
    });
    css += makeStyle('.breadcrumb > li > .divider', {
      'color': backgroundColor.shade(.2).hex6()
    });
    css += makeStyle('.breadcrumb .active', {
      'color': backgroundColor.shade(.5).hex6()
    });

    css += makeStyle('.page-header', {
      'border-color': backgroundColor.shade(.1).hex6()
    });
    css += makeStyle('.page-header h1 i', {
      'color': linkColor.tone(.7).hex6()
    });
    css += makeStyle('.page-header h1 small i', {
      'color': backgroundColor.shade(.3).hex6()
    });

    css += makeStyle('.iio-nav .subnav-item a', {
      'color': linkColor.tone(.7).hex6()
    });
    css += makeStyle('.iio-nav .subnav-item.active > a, ' +
      '.iio-nav .subnav-item.active > a:hover, ' +
      '.iio-nav .subnav-item.active > a:focus', {
      'background-color': linkColor.tone(.7).hex6()
    });
    // Bootstrap overrides

    // Tables
    css += makeStyle('table, .table th, .table td', {
      'border-color': backgroundColor.shade(.1).hex6()
    });
    css += makeStyle('.table-hover tbody tr:hover > td, ' +
      '.table-hover tbody tr:hover > th', {
      'background-color': backgroundColor.shade(.025).hex6()
    });

    // Tabs need to look like the normal background color
    css += makeStyle('.nav-tabs', {
      'border-color': backgroundColor.shade(.1).hex6()
    });
    css += makeStyle('.nav-tabs > .active > a, ' +
      '.nav-tabs > .active > a:hover, ' +
      '.nav-tabs > .active > a:hover, ' +
      '.nav-tabs > .active > a:focus', {
      'color': textColor.tint(.4).hex6(),
      'background-color': theme.backgroundColor,
      'border-color': backgroundColor.shade(.1).hex6(),
      'border-bottom-color': 'transparent'
    });
    css += makeStyle('.nav-tabs > li > a:hover, .nav-tabs > li > a:focus', {
      'border-color': backgroundColor.shade(.1).hex6() + ' ' +
        backgroundColor.shade(.1).hex6() + ' ' +
        backgroundColor.shade(.2).hex6()
    });

    css += makeStyle('.nav > li > a:hover, .nav > li > a:focus', {
      'background-color': backgroundColor.shade(.05).hex6()
    });

    // Navs and dropdown menus need the link color background
    css += makeStyle('.iio-nav > .active > a, ' +
      '.iio-nav > .active > a:hover, ' +
      '.dropdown-menu > .active > a, ' +
      '.dropdown-menu > .active > a:hover, ' +
      '.dropdown-menu > .active > a:focus, ' +
      '.dropdown-menu > li > a:hover, ' +
      '.dropdown-menu > li > a:focus, ' +
      '.dropdown-submenu:hover > a, ' +
      '.dropdown-submenu:focus > a', {
      'background-color': theme.linkColor
    });

    // Primary Button
    css += makeStyle('.btn-primary', {
      'background-color': theme.linkColor
    });
    css += makeStyle('.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .btn-primary.disabled, .btn-primary[disabled]', {
      'background-color': primaryActive
    });
    css += makeStyle('.btn-primary:active, .btn-primary.active', {
      'background-color': primaryActive
    });

    // Navbar
    css += makeStyle('.navbar-inverse .navbar-inner', {
      'background-color': theme.navBackgroundColor,
      'color': theme.navTextColor
    });
    css += makeStyle('.navbar-inverse .btn-inverse', {
      'background-color': navColor.tint(.2).hex6(),
    });
    css += makeStyle('.navbar-inverse .btn-group.open .btn-inverse.dropdown-toggle', {
      'background-color': navColor.shade(.1).hex6(),
    });

    // Forms
    css += makeStyle('.form-actions', {
      'background-color': backgroundColor.shade(.1).hex6(),
      'border-color': backgroundColor.shade(.2).hex6()
    });
    css += makeStyle('legend', {
      'border-color': backgroundColor.shade(.1).hex6()
    });

    //console.log(css);

    return css;
  };

  var head = $('head');
  var styleTag = null;
  var headerLogo = null;

  return {
    restrict: 'A',
    scope: false,
    link: function (scope, element, attrs) {

      scope.theme = ThemeService.getCurrentTheme();
      scope.$on(ThemeService.EVENTS.THEME_CHANGED, function (evt, theme) {
        scope.theme = theme;
      });

      scope.$watch('theme', function (val) {
        if (!_.isEmpty(val)) {
          console.log('Setting theme css');

          if (styleTag) {
            styleTag.remove();
          }
          styleTag = $('<style type="text/css">' + getThemeCss(val) + '</style>');
          styleTag.appendTo(head);

          $('head title').text(val.name);

          if (val['messageType'] && val['message']) {
            $('#themeMessage')
              .addClass('alert-' + val['messageType'])
              .text(val['message'])
              .show();
          }
        }
      });


    }
  }
}]);

